module.exports = __webpack_public_path__ + "static/media/anage-variedade-imoveis.93fe427b.webp";